import { createContext, ReactNode, useContext } from "react";
import { Edge, Node } from "reactflow";

type TakeSnapshotFn = (nodes: Node[], edges: Edge[]) => void;

interface HistoryContextType {
  takeSnapshot: TakeSnapshotFn | null;
}

const HistoryContext = createContext<HistoryContextType>({ takeSnapshot: null });

interface HistoryProviderProps {
  children: ReactNode;
  takeSnapshot: TakeSnapshotFn;
}

/**
 * Provider component that makes the takeSnapshot function available to all child components.
 * Used by node components to record state before configuration changes.
 */
export const HistoryProvider = ({ children, takeSnapshot }: HistoryProviderProps) => {
  return <HistoryContext.Provider value={{ takeSnapshot }}>{children}</HistoryContext.Provider>;
};

/**
 * Hook to access the history takeSnapshot function.
 * Returns null if used outside of HistoryProvider (which is fine, snapshot just won't be taken).
 */
export const useHistory = (): TakeSnapshotFn | null => {
  const context = useContext(HistoryContext);
  return context.takeSnapshot;
};
